<template>
  <div class="charge">
    <div class="toolBar" id="main">
      <p>
        <label>患者姓名：</label>
        <Input v-model="name" placeholder="患者姓名" />
      </p>
      <p>
        <label>医生：</label>
        <Input v-model="doctor" placeholder="医生"/>
      </p>
      <p>
        <label>自定义日期：</label>
        <DatePicker type="date" :options="options3" format="yyyy-MM-dd" @on-change="startTime" placeholder="开始日期" v-model="startDate"></DatePicker>
         —
        <DatePicker type="date" :options="options3" format="yyyy-MM-dd" @on-change="endTime" placeholder="结束日期·" v-model="endDate"></DatePicker>
      </p>
      <p>
        <Button type="primary" @click="search">查询</Button>
      </p>
    </div>
    <div class="mainBox">
       <Table :height="tableHeight" ref="table" :columns="columns1" :data="data1"></Table>
       <div class="pageBox">
         <Page :total="total" :transfer='true' show-elevator show-sizer @on-change="changePage" @on-page-size-change="changePageSize" />
       </div>
    </div>
    <Modal 
        class="infoModal"
        :name="modelName"
        v-model="modal1"
        :title="modelTitle"
        @on-ok="okChargeBtn"
        @on-cancel="cancelChargeBtn">
        <p><Icon :custom="modeIcon" :color="iconColor"></Icon> {{modelContent}}</p>
    </Modal>
    <Modal 
        width="60%"
        :name="modelName"
        v-model="modal2"
        :title="modelTitle"
        :scrollable="true"
        @on-ok="confirm"
        @on-cancel="cancel">
        <div class="accountBox">
          <div class="basiInfo">
            <p>
              <span>患者：</span>
              <span class="keyName" v-if="patientName">{{patientName}}</span>
            </p>
            <p>
              <span>性别：</span>
              <span v-if="sexName">{{sexName}}</span>
            </p>
            <p>
              <span>年龄：</span>
              <span v-if="age||ageUnit">{{age}}{{ageUnit}}</span>
            </p>
            <p>
              <span>医生：</span>
              <span v-if="doctorName">{{doctorName}}</span>
            </p>
            <p>
              <span>就诊日期：</span>
              <span v-if="diagnosisTime">{{diagnosisTime}}</span>
            </p>
            <p>
              <span>诊断：</span>
              <span v-if="diagnosis">{{diagnosis}}</span>
            </p>
          </div>
          <div class="projectBox" v-if="projectItems">
            <p>检测项目</p>
            <ul>
              <li>
                <span>项目名称</span>
                <span>金额</span>
              </li>
              <li v-for="(pro,index) in projectItems" v-bind:key="index">
                <span>{{pro.projectName}}</span>
                <span>{{pro.price}}</span>
              </li>
            </ul>
          </div>
          <div class="projectBox">
            <p v-if="otherItems">其他收费</p>
            <ul v-if="otherItems">
              <li>
                <span>收费项目</span>
                <span>金额</span>
              </li>
              <li v-for="(other,index) in otherItems" v-bind:key="index">
                <span>{{other.itemsName}}</span>
                <span>{{other.price}}</span>
              </li>
            </ul>
            <div class="payBox">
              <ul>
                <li>
                  <label>付款方式：</label>
                  <p>
                    <RadioGroup v-model="payType">
                      <Radio :label="ptype.value" v-for="(ptype,index) in payTypeList" v-bind:key="index">
                        <Icon :custom="ptype.icon"></Icon>
                        <span>{{ptype.label}}</span>
                      </Radio>
                    </RadioGroup>
                  </p>
                </li>
                <li>
                  <label>付款金额：</label>
                  <p>
                    <Input v-model="payPrice" style="width: 100px" />
                    <span>元</span>
                  </p>
                </li>
                <!-- <li>
                  <label>找零：</label>
                  <p>
                    <span>{{change}}</span>
                  </p>
                </li> -->
                <li class="actualPrice">
                  <p>
                    <span>实收金额：</span>
                    <span>{{actualAmount}}</span>
                    <span>元</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div slot="footer">
          <Button type="primary" size="large" @click="confirm">收费</Button>
          <Button type="text" size="large" @click="cancel">取消</Button>
        </div>
    </Modal>
    
    <Modal
      width="60%"
      :name="modelName3"
      v-model="modal3"
      :title="modelTitle3"
      :scrollable="true"
      @on-ok="confirmPrint"
      @on-cancel="cancelPrint">
      <div id="appInfo">
        <app-note :project="myInfo" ></app-note>
      </div>
      <div slot="footer">
        <Button type="text" size="large" @click="cancelPrint">取消</Button>
        <Button type="primary" size="large" @click="confirmPrint">打印</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import AppNote from "@/views/common/AppNote.vue";
import {getLodop} from '@/assets/js/LodopFuncs.js'
import {baseImg} from "@/config"
import {
  waitChargeDetail,noChargeList,
  cancelWaitCharge,charge
} from "../../../api/charge";
import {samplingDetail} from "../../../api/clinic";
import { tips,replaceT } from "../../../tools";
export default {
  name: 'WaitCharge',
  components:{AppNote},
  inject: ['reload'],
  data () {
    return {
      tableHeight:632,//表格高度初始化
      forStr:'',//循环html
      caseId:[],//返回的病例id
      myInfo:{},
      options3:{
        disabledDate (date) {
          return date && date.valueOf() > Date.now();
        }
      },
      modal1:false,
      modelName:'',
      modeIcon:'',
      iconColor:'',
      modelTitle:'',
      modelContent:'',
      modal3:false,
      modelName3:'',
      modeIcon3:'',
      iconColor3:'',
      modelTitle3:'',
      modelContent3:'',
      actualAmount:0,
      chargeId:0,
      cancelId:0,//取消id
      modelName:'',
      modal2:false,
      modelTitle:'',
      total:0,
      pageCurrent:1,
      pageSize: 10,
      name:'',//患者姓名/手机号
      doctor:'',//医生
      clinicTime:'',//就诊时间
      clinicTimeList:[],
      startDate:'',//开始日期
      endDate:'',//结束日期
      chargeCategory:'',//收费门类
      chargeCategorys:[],
      columns1:[
        {
          title: '患者',
          key: 'hospitalPatientName',
          align:'center'
        },
        {
          title: '电话',
          key: 'mobile',
          align:'center'
        },
        {   
          title: '性别',
          key: 'sex',
          align:'center',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: params.row.sex==1?'男':'女' 
              },
            })
          }
        },
        {
            title: '年龄',
            key: 'age',
            align:'center'
        },
        {
            title: '年龄单位',
            key: 'ageUnit',
            align:'center'
        },
        {
            title: '医生',
            key: 'doctorName',
            align:'center'
        },
        {
            title: '就诊日期',
            key: 'diagnosisTime',
            align:'center',
            // render:(h,params) =>{
            //   return replaceT(params.row.diagnosisTime);
            // }
            render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: replaceT(params.row.diagnosisTime) 
              },
            })
          }
        },
        {
            title: '总金额(元)',
            key: 'amount',
            align:'center'
        },
        {
          width:222,
          title: '操作',
          align:'center',
          key: 'methods',
          align: 'center',
          minWidth:120,
          render: (h, params) => {
            return h('div',{
              style: {
                  textAlign: 'center'
                }
              },
              [
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-shoufei3'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#2778E7',
                    color:'#2778E7'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.modal2 = true;
                      this.modelName = 'chargeDetail';
                      this.modelTitle = '待收费详情';
                      let id = params.row.id;
                      this.change = ''; 
                      this.payPrice = 0;
                      if(id>0){
                        this.waitChargeDetail(id,params.row);
                      }
                    },
                  }
                }, '收费'),
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-shoufei3'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#2778E7',
                    color:'#2778E7'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      // this.modal3 = true;
                      this.modelName = 'printDetail';
                      this.modelTitle = '打印详情';
                      let id = params.row.id;
                      if(id>0){
                        this.waitChargeDetail(id,params.row);
                      }
                    },
                  }
                }, '打印'),
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-guanbi1'
                  },
                  style: {
                    textAlign:'center',
                    borderColor:'#C9C9C9',
                    color:'#595757'
                  },
                  on: {
                    click: () => {
                      let id = params.row.id;
                      this.cancelId = id;
                      this.modal1 = true;
                      this.modelName = 'cancelCharge';
                      this.modelTitle = '系统提示';
                      this.modelContent = '是否取消收费?';
                      this.modeIcon = ' iconfont icon-Group-';
                      this.iconColor='#FE6E6E';
                    }
                  }
                }, '取消'),
            ]);
          }
        }
      ],
      data1:[],
      patientName:'',
      sexName:'',
      age:0,
      ageUnit:'',
      doctorName:'',
      diagnosisTime:'',
      diagnosis:'',
      projectItems:[],
      otherItems:[],
      payPrice:0,
      change:'0.00',//找零
      payType:1,
      payTypeList:[
        {
          label:'现金',
          value:1,
          icon:' iconfont icon-zhanghuyue'
        },
        {
          label:'医保',
          value:2,
          icon:' iconfont icon-yibao'
        },
        {
          label:'微信',
          value:3,
          icon:' iconfont icon-weixinzhifu'
        },
        {
          label:'支付宝',
          value:4,
          icon:' iconfont icon-zhifubao'
        },
        {
          label:'银联',
          value:5,
          icon:' iconfont icon-yinhangqia'
        },
        {
          label:'其他',
          value:6,
          icon:''
        }

      ]
    }
  },
  created(){
    let lett = this;
    document.onkeydown = function(e) {
    let key = window.event.keyCode;
    if (key == 13) {
      lett.search();
      }
    }
  },
  mounted(){
    window.addEventListener('resize', this.getTableHeight);
    this.getTableHeight();
    this.caseId = this.$route.query.caseId;
    if(this.caseId>0){
      this.modal2 = true;
      this.waitChargeDetail(this.caseId)
    }
    this.loadList();
  },
  methods:{
    getTableHeight(){
      // 设置表格高度 
      if(this.$refs){
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop-90; 
      }

    },
    loadList(){
      this.search();
    },
    //搜索
    search(){
      let _this = this;
      let params = {
        current: _this.pageCurrent,
        endTimes: _this.endDate,
        name: _this.doctor,
        nameAndPhone: _this.name,
        size: _this.pageSize,
        starTimes: _this.startDate
      };
      noChargeList(
        params
      ).then(res => {
        console.log(res)
        let data = res.records;
        _this.total = res.total;
        _this.data1 = data;
      });
    },
    // 收费详情
    waitChargeDetail(id,params){
      let _this = this;
      waitChargeDetail({
        id:id
      }).then(res =>{
        console.log(res);
        _this.chargeId = res.id;
        _this.actualAmount = res.amount;
        _this.patientName = res.hospitalPatientName;
        _this.sexName = res.sex==1?'男':'女';
        _this.age = res.age;
        _this.ageUnit = res.ageUnit;
        _this.doctorName = res.doctorName;
        _this.diagnosisTime = replaceT(res.diagnosisTime);
        _this.diagnosis = res.diagnosis;
        _this.projectItems = res.hisProjectVos;
        _this.otherItems = res.hisOtherOrihechVos;

        if(this.modelName=='printDetail'){
          if(res.hisProjectIds){
            this.samplingDetail(res.hisProjectIds,res);
          }else{
            this.getPrint(res,[]);
          }
        }
      })
    },
    getPrint(data,sampItems){
      var LODOP=getLodop();
      this.createPrintPage(data,sampItems);
      // LODOP.PRINT_SETUP();
      // LODOP.PRINT_DESIGN();	
      LODOP.PREVIEW();
    },
    //调取打印
    createPrintPage(data,sampItems){
      console.log(sampItems);
      console.log(data);
      var LODOP=getLodop();
      // console.log(this.myInfo);
      console.log(sampItems);
      let forStr = '';
      if(sampItems){
        
        for(let i=0;i<sampItems.length;i++){
          forStr += `<tr><td><span></span></td>
          <td>${sampItems[i].proNameItem}</td>
            <td>${sampItems[i].samplingColor}</td>
            <td>${sampItems[i].specimenTypeName}(${sampItems[i].count}${sampItems[i].unitName})</td>
            <td>${sampItems[i].samplingNum}</td>
          </tr>`;
        }
        // console.log(forStr);
      }
      if(data.hisProjectVos){
        let proArr = [];
        for(let i=0;i<data.hisProjectVos.length;i++){
          proArr.push(data.hisProjectVos[i].projectName);
        }
        console.log(proArr);
        data.proName = proArr.join(',');
      }else{
        data.proName = '';
      }
      
      let myInfo = data;
      let footStr = `<div class="price" style="display: flex;justify-content: space-between;padding: 10px 10%;margin-top:10px;">
        <div style="display: flex;margin-right: 20px;">
          <p style="font-size: 14px;line-height: 30px;">样本性状：</p>
          <p style="font-size: 14px;line-height: 30px;">
            <span style="font-size:12px;"><i class="display:inline-block;width:10px;height:10px;border:1px solid #c9c9c9;"></i>正常</span>
            <span style="font-size:12px;"><i></i>脂浊</span>
            <span style="font-size:12px;"><i></i>轻度溶血</span>
            <span style="font-size:12px;"><i></i>量少</span>
            <span style="font-size:12px;"><i></i>其他</span>
          </p>
        </div>
        <p style="display: flex;">
          <span style="display: inline-block;line-height: 30px;font-size: 14px; ">采样时间：</span>
          <span class="text" style="min-width: 100px;height: 24px; display: inline-block;line-height: 30px;font-size: 14px; "></span>
        </p>
        </div>`;
      // console.log(footStr);
      let strHtml = `<style>table,td,th {border: 1px solid black;border-style: solid;border-collapse: collapse;text-align:center;}
        table{width:84%;}tr{min-height:30px;paddind:10px;}td{width:20%;}.price>div>p>span>i{display:inline-block;width:10px;height:10px;border: 1px solid #c9c9c9;}</style><table border="1"><tr><td>项目名称：</td>
        <td colspan="4">${myInfo.proName}</td></tr><tr><td>条码粘贴处</td><td>项目明细</td><td>采集容器</td><td>样本类型</td><td>总量</td>
        </tr>`+forStr+`</table><table>`;
        // <div style="height:50px;margin-top:20px;">${footStr}</div>
      // console.log(strHtml);
      // let tab = 
      // document.documentElement.clientHeight(height+padding)
      LODOP.PRINT_INITA(17,43,800,600,"检验申请单");
      LODOP.ADD_PRINT_TEXT(54,369,143,30,"检验申请单");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",14);
      LODOP.SET_PRINT_STYLEA(0,"Horient",2);
      LODOP.SET_PRINT_STYLEA(0,"Vorient",3);
      LODOP.ADD_PRINT_TEXT(90,0,800,20,"-----------------------------------------------------------------------------------------------------------------------");
      LODOP.SET_PRINT_STYLEA(0,"Horient",2);
      LODOP.ADD_PRINT_TEXT(120,0,50,24,"姓名:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXTA("name",120,50,70,24,myInfo.hospitalPatientName);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(120,120,50,24,"性别:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXTA("sex",120,165,30,24,myInfo.sex==1?'男':'女');
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(120,205,50,24,"年龄:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(120,305,50,24,"科室:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXTA("age",120,255,50,24,myInfo.age+myInfo.ageUnit);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXTA("department",120,355,70,24,myInfo.departmentName);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(120,425,50,24,"床号:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(120,476,50,24,"   ");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.SET_PRINT_STYLEA(0,"Underline",1);
      LODOP.ADD_PRINT_TEXT(120,540,70,24,"就诊号:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(120,605,95,24,"     ");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.SET_PRINT_STYLEA(0,"Underline",1);
      LODOP.ADD_PRINT_TEXT(160,0,89,24,"送检医生:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXTA("doctorName",160,89,60,24,myInfo.doctorName);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(160,150,90,24,"下单时间:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXTA("orderTime",160,239,170,24,replaceT(myInfo.diagnosisTime));
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(160,417,90,24,"临床诊断:");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(160,505,193,24,myInfo.diagnosis);
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.SET_PRINT_STYLEA(0,"Underline",1);

      LODOP.ADD_PRINT_TABLE(254,0,800,400,strHtml);
      LODOP.ADD_PRINT_IMAGE(35,-5,135,52,`<img src='${baseImg}appLogo.png'>`);
      LODOP.SET_PRINT_STYLEA(0,"Stretch",2);
      LODOP.ADD_PRINT_TEXT(204,0,90,24,"样本性状：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_RECT(206,91,10,10,0,1);
      LODOP.ADD_PRINT_TEXT(204,102,50,24,"正常");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(204,162,50,24,"脂浊");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_RECT(206,152,10,10,0,1);
      LODOP.ADD_PRINT_RECT(206,212,10,10,0,1);
      LODOP.ADD_PRINT_TEXT(204,223,80,24,"轻度溶血");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_RECT(206,305,10,10,0,1);
      LODOP.ADD_PRINT_TEXT(204,316,50,24,"量少");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(204,462,90,24,"采样时间：");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.ADD_PRINT_TEXT(204,552,100,24,"        ");
      LODOP.SET_PRINT_STYLEA(0,"FontSize",12);
      LODOP.SET_PRINT_STYLEA(0,"Underline",1);
    },
    //通过projectId查询样本
    samplingDetail(ids,data){
      // console.log(data);
      samplingDetail({
        orderIds:ids
      }).then(res=>{
        let sampArr = []; 
        let sampItems = res;
        
        for(let i=0;i<sampItems.length;i++){
          // console.log(sampItems[i].list);
          let subArr = []
          for(let j=0;j<sampItems[i].list.length;j++){
            subArr.push(sampItems[i].list[j].projectName);
          }
          // console.log(subArr.join(','));
          // console.log(sampItems);
          this.$forceUpdate();
          this.$set(sampItems[i],'proNameItem',subArr.join(','));
          // sampArr.push(subArr.join(','));
        }
        console.log(sampItems);
        
        this.getPrint(data,sampItems);
      });
    },
    //收费
    charge(){
      let _this = this;
      let projectIds = [];
      let otherIds = [];
      let proArr = [];
      let otherArr = [];
      if(_this.projectItems){
        for(let i=0;i<_this.projectItems.length;i++){
          proArr.push(_this.projectItems[i].id);
        }
        projectIds = proArr;
      }
      console.log(projectIds)
      if(_this.otherItems){
        for(let j=0;j<_this.otherItems.length;j++){
          otherArr.push(_this.otherItems[j].id)
        }
        otherIds = otherArr;
      }
      
      console.log(otherIds)
      let params = {
        actualAmount: _this.actualAmount,
        id: _this.chargeId,
        otherIds: otherIds,
        payType: _this.payType,
        projectIds: projectIds
      };
      console.log(params)
      charge(
        params
      ).then(res => {  
        console.log(res);
        tips(this,res,'success');
        // location.reload();
        this.modal2 = false;
        this.reload();
        this.$router.push({path:'havecharge'});
      })
    },
    //取消
    cancelCharge(id){
      let _this = this;
      cancelWaitCharge({
        id:id
      }).then(res => {
        console.log(res);
        tips(this,res,'success');
        _this.loadList();
      });
    },
    //改变页码
    changePage(current){
      this.pageCurrent = current;
      this.loadList();
    },
    //改变每页条数
    changePageSize(size){
      this.pageSize = size;
      this.loadList();
    },
    confirm(){
      this.charge();
    },
    cancel(){
      this.modal2 = false;
    },
    startTime(e){
      this.startDate = e;
      console.log(e)
    },
    endTime(e){
      this.endDate = e;
      console.log(e)
    },
    okChargeBtn(){
      if(this.modelName=='cancelCharge'){
        this.cancelCharge(this.cancelId);
      }
    },
    cancelChargeBtn(){
      this.modal1 = false;
    },
    confirmPrint(){
      this.printPdf()
      this.$router.push({path:'appnote'})
    },
    cancelPrint(){
      this.modal3 = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.charge{

}
.charge .toolBar{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap ;
  padding: 10px 0;
}
.charge .toolBar>p{
  padding: 5px 0;
  margin-right: 20px;
}
.charge .toolBar>p>label{
  display: inline-block;
}
.pageBox{
  text-align: center;
  padding: 5px 0;
}
.ivu-input-wrapper{
  width: 120px;
}
.ivu-select{
  width: 120px;
  /* width: 100%; */
}
.ivu-date-picker{
  width: 120px;
}

/* 详情弹框 */
.accountBox{
  width: 100%;
}
.accountBox /deep/ .ivu-modal{
  height: 600px;
  overflow: hidden;
}
.accountBox /deep/ .ivu-modal-content{
  height: 100%;
  overflow: hidden;
}
.ivu-modal-body{
  font-size: 14px;
  overflow: scroll;
  height: 300px;
}
.basiInfo{
  display: flex;
  flex-flow: wrap row;
  justify-content: flex-start;
  padding: 0 10px 8px;
  border-bottom: 1px solid #c9c9c9;
}
.basiInfo>p{
  margin-right: 30px;
  line-height: 32px;
}
.basiInfo>p>span:nth-child(2){
  padding-right: 30px;
  border-right: 1px solid #c9c9c9;
}
.basiInfo .keyName{
  color: #2778e2;
}
.projectBox{
  width: 100%;
}
.projectBox>p{
  padding: 10px 0;
  color:#030303;
  font-size: 14px;
  margin-left: 10px;
}
.projectBox>ul{
  width: 100%;
  border: 1px solid #c9c9c9;
}
.projectBox>ul>li{
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c9c9c9;
}
.projectBox>ul>li:last-child{
  border: none;
}
.projectBox>ul>li>span{
  text-align: center;
  width: 50%;
}
.projectBox>ul>li:first-child{
  height: 39px;
  line-height: 39px;
  border-bottom: 1px solid #c9c9c9;
}
.projectBox>ul>li:first-child>span{
  color: #030303;
}
.payBox{
  width: 100%;
}
.payBox>ul{
  width: 100%;
}
.payBox>ul>li{
  display: flex;
  justify-content: flex-start;
  height: 40px;
  line-height: 40px;
}
.payBox>ul>li>label{
  width: 100px;
  text-align: right;
}
.payBox .actualPrice{
  display: flex;
  justify-content: flex-end;
}
.payBox .actualPrice>p{
  margin-right: 10px;
}
.payBox .actualPrice>p>span{
  font-size: 14px;
}
.payBox .actualPrice>p>span:nth-child(2){
  color: #ff4568;
  font-size: 20px;
}
.icon-zhanghuyue{
  color: #fd605f;
}
.icon-yibao{
  color: #06a0a2;
}
.icon-weixinzhifu{
  color: #00ab45;
}
.icon-zhifubao{
  color: #289bd6;
}
.icon-yinhangqia{
  color: #ff9d2d;
}
.infoModal /deep/ .ivu-modal-content {
    height: auto;
    min-height: 0;
}
.top{
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/charge/waitcharge/WaitCharge.vue